import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { BaseEntityResponseDto } from '@sphere/shared/domain';

export class ActivityStatsResponseDto extends BaseEntityResponseDto {
  @ApiProperty({ type: 'string' })
  activityId!: string;

  @ApiProperty({ type: Number, description: 'Nombre total de tentatives' })
  totalAttempts!: number;

  @ApiProperty({ type: Number, description: "Nombre d'utilisateurs uniques" })
  uniqueUsers!: number;

  @ApiPropertyOptional({ type: Number, description: 'Score moyen (0-100)', nullable: true })
  avgScore!: number | null;

  @ApiPropertyOptional({ type: Number, description: 'Durée moyenne (sec)', nullable: true })
  avgDurationSec!: number | null;

  @ApiPropertyOptional({ type: Number, description: 'Taux de réussite (0-100)', nullable: true })
  successRate!: number | null;

  @ApiProperty({ description: 'Distribution des scores par tranches', type: Object })
  scoreDistribution!: Record<string, number>;

  @ApiProperty({ description: 'Erreurs fréquentes', type: Object })
  commonMistakes!: Record<string, any>;

  @ApiProperty({ type: 'string', format: 'date-time' })
  lastCalculatedAt!: string | Date;

  @ApiPropertyOptional({ description: 'Capabilities calculées', type: Object })
  capabilities?: Record<string, boolean>;
}
